// skills images
export const myphoto = require("./images/myphoto.jpg");

// achievements images
export const leetcode = require("./platform-images/leetcode.png");
export const gfg = require("./platform-images/gfg.png");
export const hackerrank = require("./platform-images/hackerrank.png");
export const codechef = require("./platform-images/codechef.png");
export const codeforces = require("./platform-images/codeforces.png");
export const atcoder = require("./platform-images/atcoder.png");

//oops image
export const oops = require("./platform-images/oops.jpg");

// news project images
export const nprj1 = require("./project-images/news-project/1.png");
export const nprj2 = require("./project-images/news-project/2.png");
export const nprj3 = require("./project-images/news-project/3.png");
export const nprj4 = require("./project-images/news-project/4.png");
export const nprj5 = require("./project-images/news-project/5.png");
export const nprj6 = require("./project-images/news-project/6.png");
export const nprj7 = require("./project-images/news-project/7.png");
export const nprj8 = require("./project-images/news-project/8.png");
export const nprj9 = require("./project-images/news-project/9.png");
export const nprj10 = require("./project-images/news-project/10.png");
export const nprj11 = require("./project-images/news-project/11.png");

// portfolio images
export const pf1 = require("./project-images/portfolio/1.png");
export const pf2 = require("./project-images/portfolio/2.png");
export const pf3 = require("./project-images/portfolio/3.png");
export const pf4 = require("./project-images/portfolio/4.png");
export const pf5 = require("./project-images/portfolio/5.png");
export const pf6 = require("./project-images/portfolio/6.png");
export const pf7 = require("./project-images/portfolio/7.png");
export const pf8 = require("./project-images/portfolio/8.png");
export const pf9 = require("./project-images/portfolio/9.png");
export const pf10 = require("./project-images/portfolio/10.png");
export const pf11 = require("./project-images/portfolio/11.png");
export const pf12 = require("./project-images/portfolio/12.png");
export const pf13 = require("./project-images/portfolio/13.png");

// phone directory images
export const pdir1 = require("./project-images/phone-directory/1.png");
export const pdir2 = require("./project-images/phone-directory/2.png");
export const pdir3 = require("./project-images/phone-directory/3.png");
export const pdir4 = require("./project-images/phone-directory/4.png");
export const pdir5 = require("./project-images/phone-directory/5.png");
export const pdir6 = require("./project-images/phone-directory/6.png");
export const pdir7 = require("./project-images/phone-directory/7.png");
export const pdir8 = require("./project-images/phone-directory/8.png");
export const pdir9 = require("./project-images/phone-directory/9.png");

// tailwind images
export const tw1 = require("./project-images/tailwindCss/1.png");
export const tw2 = require("./project-images/tailwindCss/2.png");
export const tw3 = require("./project-images/tailwindCss/3.png");
export const tw4 = require("./project-images/tailwindCss/4.png");
export const tw5 = require("./project-images/tailwindCss/5.png");
export const tw6 = require("./project-images/tailwindCss/6.png");
export const tw7 = require("./project-images/tailwindCss/7.png");
export const tw8 = require("./project-images/tailwindCss/8.png");

// netflix images
export const mf1 = require("./project-images/movieflixo/1.png");
export const mf2 = require("./project-images/movieflixo/2.png");
export const mf3 = require("./project-images/movieflixo/3.png");
export const mf4 = require("./project-images/movieflixo/4.png");
export const mf5 = require("./project-images/movieflixo/5.png");

// taskIO images
export const tio1 = require("./project-images/TaskIO/1.png");
export const tio2 = require("./project-images/TaskIO/2.png");
export const tio3 = require("./project-images/TaskIO/3.png");
export const tio4 = require("./project-images/TaskIO/4.png");
export const tio5 = require("./project-images/TaskIO/5.png");
export const tio6 = require("./project-images/TaskIO/6.png");
export const tio7 = require("./project-images/TaskIO/7.png");
export const tio8 = require("./project-images/TaskIO/8.png");

// face recognizer image
export const fr1 = require("./project-images/Face-Recognizer/1.png");
export const fr2 = require("./project-images/Face-Recognizer/2.png");
export const fr3 = require("./project-images/Face-Recognizer/3.png");
export const fr4 = require("./project-images/Face-Recognizer/4.png");
export const fr5 = require("./project-images/Face-Recognizer/5.png");

// movie recommendation image
export const mr1 = require("./project-images/MovieRecommendation/1.png");
export const mr2 = require("./project-images/MovieRecommendation/2.png");
export const mr3 = require("./project-images/MovieRecommendation/3.png");
export const mr4 = require("./project-images/MovieRecommendation/4.png");
export const mr5 = require("./project-images/MovieRecommendation/5.png");

// ImageCaptioning images
export const icap1 = require("./project-images/ImageCaptioning/1.png");
export const icap2 = require("./project-images/ImageCaptioning/2.png");
export const icap3 = require("./project-images/ImageCaptioning/3.png");
export const icap4 = require("./project-images/ImageCaptioning/4.png");
export const icap5 = require("./project-images/ImageCaptioning/5.png");

// Synthetic mnist data generation images
export const smnist1 = require("./project-images/SyntheticMnistDataGeneration/1.png");
export const smnist2 = require("./project-images/SyntheticMnistDataGeneration/2.png");
export const smnist3 = require("./project-images/SyntheticMnistDataGeneration/3.png");
export const smnist4 = require("./project-images/SyntheticMnistDataGeneration/4.png");
export const smnist5 = require("./project-images/SyntheticMnistDataGeneration/5.png");
